<template>
  <div :class="[from?'':'app-main-inner']">
    <div class="section">
      <span class="title">{{ $t('SeaExport.Warehouse2') }}</span>
      <div class="warehouse-wrap">
        <el-form :disabled="readonly" label-width="100px" label-position="left">
          <el-form-item :label="$t('SeaExport.LoadingCharge2')" class="custom">
            <el-input-number v-model="packingChargeAmount" no="1" :disabled="!chargeEnable" :precision="2" :min="0" :max="999999999999" controls-position="right" @change="dealPackingCharge" />
            <span>{{ localCurrency }}</span>
            <template v-if="isZh">
              <label>{{ $t('SeaExport.RmbNumberOfDamagedAndDamp') }}</label>
              <el-input-number no="2" :value="warehouseInfo.quantity===0 ? undefined: warehouseInfo.quantity" :precision="0" :min="0" :max="999999999999" controls-position="right" @input="val=>{warehouseInfo.quantity=val}" />
            </template>
          </el-form-item>
          <el-form-item v-if="!isZh" :label="$t('SeaExport.RmbNumberOfDamagedAndDamp2')" class="custom">
            <el-input-number no="3" :value="warehouseInfo.quantity===0 ? undefined: warehouseInfo.quantity" :precision="0" :min="0" :max="999999999999" controls-position="right" @input="val=>{warehouseInfo.quantity=val}" />
          </el-form-item>

          <el-form-item :label="warehouseCmpLabel" class="auto-width">
            <cargo-company-select
              no="4"
              :method-params="{warehouse:true,active:true}"
              :default-value="warehouseInfo.warehouseCmp||''"
              style="width: 400px"
              @change="p=>{warehouseInfo.warehouseCmp=p.value||0;warehouseChangeHandler(p.value)}"
            />
          </el-form-item>

          <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')" class="custom">
            <el-select
              v-if="openWarehouse"
              ref="advanceSelectRef"
              v-model="warehouseInfo.warehouseName"
              no="5"
              :allow-create="true"
              filterable
              :clearable="true"
              style="width:400px;"
              @change="nameChangeHandler"
              @visible-change="onVisibleChange"
            >
              <el-option
                v-for="(item,index) in warehouseNameList"
                :key="index"
                :label="item.warehouseName"
                :value="item.warehouseName"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('SeaExport.WarehouseAddress')" class="custom">
            <el-input v-model="warehouseInfo.warehouseAddress" no="6" type="textarea" :rows="5" style="width:400px" />
          </el-form-item>
        </el-form>

        <el-form :disabled="readonly" label-width="100px" label-position="left">
          <el-form-item :label="$t('SeaExport.ContactWay')">
            <el-input v-if="openWarehouse" v-model="warehouseInfo.warehouseContact" no="7" style="width:400px" />
            <el-select
              v-if="!openWarehouse"
              v-model="warehouseInfo.warehouseContact"
              no="8"
              :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              :allow-create="true"
              :clearable="true"
              filterable
              style="width:400px"
              @change="contactsChangeHandler"
              @blur="selectContactBlur"
            >
              <el-option
                v-for="(item,index) in contactList"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="warehouseInfo.warehouseContactTel" no="9" />
          </el-form-item>

          <el-form-item :label="$t('SeaExport.CargosExpectedArrivalDate')">
            <el-date-picker
              ref="arriveDate"
              v-model="warehouseInfo.arriveDate"
              no="10"
              type="datetime"
              style="width:400px"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              @blur="()=> { handleBlur('arriveDate', null, true, true, warehouseInfo) }"
            />
          </el-form-item>

          <el-form-item :label="$t('SeaExport.LoadingRemarks')" class="custom">
            <el-input v-model="warehouseInfo.remarks" no="11" type="textarea" :rows="5" style="width:400px" />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getWarehouseDetail } from '@/api/company'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { User } from '@/class/model/sys/User'
import DateUtils from '@/utils/dateUtils'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { handleBlur } from '@/utils/commonUtil'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'TabWarehouse',
  components: { CargoDateTimeFieldInput, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    from: {
      type: String,
      default: () => 'se'
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      handleBlur,
      isZh: this.$store.getters.language === 'zh',
      selectTypeNames: TYPE_NAMES,
      openWarehouse: false,
      packingChargeLocked: false,
      chargeEnable: true, // 装箱费是否允许编辑
      packingChargeAmount: 0,
      warehouseCmpLabel: '',
      warehouseInfo: new WarehouseInfo().fillDefaultValue().getData(),
      contactList: [],
      warehouseNameList: [],
      packingCharge: {},
      currentUser: {},
      job: {},
      isNeedLoadContact: true, // 是否需要加载联系人
      bakWarehouseCmp: 0 // 用于记录上一次的 仓库id，触发 warehouseChangeHandler
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look' // todo && this.job.printHblZbLock 暂无此属性
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' // todo  && !this.job.printHblZbLock 暂无此属性
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    }
  },
  watch: {
    // job上的 仓库信息修改同步 仓库 通过 bakWarehouseCmp 触发,基本页签上的 warehouseCmp 更改已经同步了warehouseInfo上的信息了
    // 'job.warehouseCmp': {
    //   handler: async function(val) {
    //     console.log('this.bakWarehouseCmp========1', this.bakWarehouseCmp, this.job.warehouseCmp)
    //     if (this.job.warehouseCmp && this.bakWarehouseCmp !== this.job.warehouseCmp) {
    //       this.contactList = this.isNeedLoadContact ? [] : this.contactList
    //       await this.warehouseChangeHandler(this.job.warehouseCmp)
    //       const fileCutoffDay = parseInt(cache.config.get('SEFileCutoffDetaultDay'))
    //       if (fileCutoffDay > 0 && this.job.etd) {
    //         this.warehouseInfo.arriveDate = DateUtils.getFourDaysAgoWithoutHoliday(this.job.etd, fileCutoffDay)
    //         this.warehouseInfo.arriveDate.setHours(16, 0)
    //       }
    //       this.warehouseInfo.warehouseCmp = this.job.warehouseCmp
    //       this.bakWarehouseCmp = this.job.warehouseCmp
    //     }
    //   },
    //   deep: true
    // }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.currentUser = cache.user
    this.departmentTeamUser = []
    User.getUserDepartmentTeam().then(data => {
      this.departmentTeamUser = data
    })
  },
  methods: {
    async onShow(row, isRefresh) {
      // 加载数据
      let jobClass = null
      if (this.job.lob === 'RE' || this.job.lob === 'RI') {
        jobClass = new RailwayExportJob(row)
      } else if (this.job.lob === 'AI') {
        jobClass = new AirImportJob(row)
      } else {
        jobClass = new SeaExportJob(row)
      }
      await Promise.all([
        this.readonly ? jobClass.getWarehouseInfo2() : jobClass.getWarehouseInfo(),
        jobClass.getCharges()
      ])
      if (isRefresh) {
        this.contactList = this.isNeedLoadContact ? [] : this.contactList
        this.job = row
        this.openWarehouse = parseInt(cache.config.get('isOpenWarehouse')) > 0
        if (this.openWarehouse) { this.warehouseCmpLabel = this.$t('SeaExport.WarehouseSupplier') } else { this.warehouseCmpLabel = this.$t('SeaExport.Warehouse') }
        await this.autoCalculateDateRule()
        await this.startLoadRelations(row)
      }
    },
    startLoadRelations() {
      this.loadResultHandler()
    },
    getSubmitData() {
      this.fillModel()
      const job = { ...this.job }
      const charges = []
      if (this.job.charges && this.job.charges.length > 0) {
        for (const charge of this.job.charges) {
          if (!charge.isDirty) continue
          charges.push(charge)
        }
      }
      // charges: this.job.charges.filter(p => p.isDirty === true), // todo 在 费用tab 未打开的情况下 需要保持charges
      const result = {
        job,
        warehouseInfo: [this.warehouseInfo]
      }
      if (charges.length > 0) result.charges = charges
      return result
    },
    async updateWarehouseCmp() {
      // console.log('this.bakWarehouseCmp========1', this.bakWarehouseCmp, this.job.warehouseCmp)
      if (this.job.warehouseCmp && this.bakWarehouseCmp !== this.job.warehouseCmp) {
        // console.log('this.bakWarehouseCmp========2', this.bakWarehouseCmp, this.job.warehouseCmp)
        this.contactList = this.isNeedLoadContact ? [] : this.contactList
        await this.warehouseChangeHandler(this.job.warehouseCmp)
        const fileCutoffDay = parseInt(cache.config.get('SEFileCutoffDetaultDay'))
        const ctrlEstArrivalDate = parseInt(cache.config.get('CtrlEstArrivalDate')) === 1
        if (fileCutoffDay > 0 && this.job.etd && ctrlEstArrivalDate) {
          this.warehouseInfo.arriveDate = DateUtils.getFourDaysAgoWithoutHoliday(this.job.etd, fileCutoffDay)
          this.warehouseInfo.arriveDate.setHours(16, 0)
        }
        this.warehouseInfo.warehouseCmp = this.job.warehouseCmp
        this.bakWarehouseCmp = this.job.warehouseCmp
      }
    },
    fillModel() {

    },
    // todo cargo 未找到对应的处理调用代码
    async dealPackingCharge() {
      this.packingChargeAmount = !this.packingChargeAmount ? '' : this.packingChargeAmount
      this.packingCharge = this.getCost()
      let charge = this.packingCharge
      if (!this.chargeIsModified(charge)) {
        return
      }
      const amount = this.packingChargeAmount
      const chargeItemId = parseInt(cache.config.get('WarehousePackingFeeCode'))
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && !charge && amount > 0) {
        charge = this.createNewCharge()
        // PACKING_FEE_CODE
        charge.chargeItemId = chargeItemId
        if (chargeItem.measure !== null && chargeItem.measure !== '') {
          charge.measure = chargeItem.measure
        }
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }

        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      await this.setChargeInfo(charge)
    },
    chargeIsModified(charge) {
      if (charge) {
        const job = this.job
        if ((job.uuid && !charge.jobUuid) || charge.jobUuid !== job.uuid || charge.verifiedAmount !== 0 || charge.billingUuid ||
          charge.billingPaymentUuid || charge.invoiceUuid || charge.shared || charge.collection ||
          (charge.chargeState !== 0 && charge.chargeState !== 3) || !this.checkRoleEdit(charge) || charge.confirmState === 1 ||
          charge.agentSharedBillingUuid) { // !shareEnable
          return false
        }
        if (charge.shareScheme > 0) {
          return false
        }
      }
      return true
    },
    /**
     * 是否同组和全部编辑权限
     */
    checkRoleEdit(charge) {
      if (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
        return true
      }
      const editArAllCharge = this.$checkPermission(['role_Charge_editArAllCharge'])
      const editArDeptCharge = this.$checkPermission(['role_Charge_editArDeptCharge'])
      const editApAllCharge = this.$checkPermission(['role_Charge_editApAllCharge'])
      const editApDeptCharge = this.$checkPermission(['role_Charge_editApDeptCharge'])
      if (charge.receivable) {
        if (editArAllCharge) {
          return true
        }
        if (editArDeptCharge && this.checkDepartmentTeam(charge)) {
          return true
        }
      } else {
        if (editApAllCharge) {
          return true
        }
        if (editApDeptCharge && this.checkDepartmentTeam(charge)) {
          return true
        }
      }
      return false
    },
    checkDepartmentTeam(charge) {
      if (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
        return true
      }
      for (const userId of this.departmentTeamUser) {
        if (userId === charge.inputBy || userId === charge.createdBy) {
          return true
        }
      }
      return false
    },
    async setChargeInfo(charge) {
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (this.packingChargeAmount !== 0 && !isNaN(this.packingChargeAmount) && this.warehouseInfo.warehouseCmp > 0) {
          charge.accountId = this.warehouseInfo.warehouseCmp
          charge.unitRate = this.packingChargeAmount
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          }
          charge.isDirty = true
        }
      }
      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
        // this.$logger.log('invoiceTitle=============', charge.invoiceTitle)
      }
      this.context.reloadCharge = true
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    /**
     * load success
     */
    loadResultHandler() {
      // 加载不需要清空 vue 数据的双向绑定
      // this.isNullData()
      this.loadDone()
    },
    loadDone() {
      if (this.job.warehouseInfo.length > 0) {
        this.isNullData()
        this.warehouseInfo = this.job.warehouseInfo[0]
        this.bakWarehouseCmp = this.warehouseInfo.warehouseCmp
      } else {
        this.warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
        this.warehouseInfo.warehouseCmp = this.job.warehouseCmp
        this.warehouseChangeHandler(this.warehouseInfo.warehouseCmp)

        this.job.warehouseInfo = []
        this.job.warehouseInfo.push(this.warehouseInfo)
      }
      // this.$logger.log('this.job.warehouseInfo=============2', this.job.warehouseInfo, this.job.warehouseInfo[0])
      // 加载 仓库，联系人
      this.loadCompanyContacts()
      this.loadPackingCharge()
    },
    loadPackingCharge() {
      this.packingChargeLocked = false
      this.packingCharge = this.getCost()
      this.packingChargeAmount = 0
      if (this.packingCharge) {
        if (this.packingCharge.paidOff ||
          !isNaN(this.packingCharge.verifiedAmount) && this.packingCharge.verifiedAmount !== 0 ||
          !StrUtils.isEmpty(this.packingCharge.invoiceUuid) ||
          !StrUtils.isEmpty(this.packingCharge.billingPaymentUuid)) {
          this.packingChargeLocked = true
        }
        this.packingChargeAmount = this.packingCharge.amount
      }
      // 装箱费是否可编辑
      if (!this.readonly) {
        this.chargeEnable = !this.packingChargeLocked && this.chargeIsModified(this.packingCharge)
      } else {
        this.chargeEnable = !this.readonly
      }
    },
    getCost() {
      // PACKING_FEE_CODE  默认装箱费
      const chargeCode = parseInt(cache.config.get('WarehousePackingFeeCode'))
      let c = null
      if (!this.job.charges) return c
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          c = charge
          return c
        }
      }
      return c
    },
    /**
     * load company contact
     */
    async loadCompanyContacts() {
      // 同步 实现 loadWarehouseDetailHandler
      if (!this.warehouseInfo || !this.warehouseInfo.warehouseCmp || this.warehouseInfo.warehouseCmp <= 0) {
        const tempRemarks = this.warehouseInfo.remarks
        this.isNullData()
        if (this.warehouseInfo.jobUuid === this.job.uuid) {
          this.warehouseInfo.remarks = tempRemarks
        }
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.warehouseInfo.warehouseCmp))
      if (!companyCache) {
        this.warehouseInfo.warehouseCmp = 0
        this.isNullData()
        return
      }
      if (this.warehouseInfo.warehouseCmp && parseInt(this.warehouseInfo.warehouseCmp) > 0 && (!this.contactList || this.contactList.length <= 0)) {
        const company = new Company({ cmpIdx: this.warehouseInfo.warehouseCmp })
        this.contactList = await company.getContactsBycmpIdx()
        this.isNeedLoadContact = false
      }
      // 获取公司下的仓库List & 默认仓库
      const warehouseDefault = await this.getDefaultWarehouse(companyCache)
      if (this.warehouseNameList && this.warehouseNameList.length > 0) {
        // 编辑
        if (!StrUtils.isEmpty(this.warehouseInfo.uuid)) {
          const b = this.checkContactList(warehouseDefault)
          if ((!this.openWarehouse) || b) {
            this.contactsOldData(this.warehouseInfo, null)
          } else {
            if (!b) {
              this.contactsOldData(null, warehouseDefault)
            }
            this.contactsOldData(this.warehouseInfo, null)
          }
        } else {
          // 新增赋值默认仓库联系人信息
          if (warehouseDefault) {
            this.warehouseInfo.warehouseContactTel = warehouseDefault.warehouseContactTel
            this.warehouseInfo.warehouseContact = warehouseDefault.warehouseContact
            this.warehouseInfo.warehouseAddress = warehouseDefault.warehouseAddress
            this.warehouseInfo.mapFile = warehouseDefault.mapFile
            this.warehouseInfo.warehouseName = warehouseDefault.warehouseName
            this.job.warehouseName = warehouseDefault.warehouseName
            if (!this.openWarehouse) {
              this.contactsOldData(null, warehouseDefault)
            }
          }
        }
      } else {
        // 没有默认仓库也不能清空，否则显示数据不对
        // this.isNullData()
      }

      if (StrUtils.isEmpty(this.warehouseInfo.uuid)) {
        this.getAddressText(companyCache, this.warehouseNameList)
      }
      // 联系人，优先取默认，无默认则随机取
      if (!this.warehouseInfo.warehouseContact && !this.warehouseInfo.warehouseContactTel && this.contactList.length > 0) {
        for (const ct of this.contactList) {
          if (ct.defaultContact) {
            this.warehouseInfo.warehouseContact = ct.contactPerson
            this.warehouseInfo.warehouseContactTel = ct.telephone
            break
          }
        }
        // if (!this.warehouseInfo.warehouseContact && !this.warehouseInfo.warehouseContactTel) {
        //   const ct = this.contactList[0]
        //   this.warehouseInfo.warehouseContact = ct.contactPerson || ''
        //   this.warehouseInfo.warehouseContactTel = ct.telephone || ''
        // }
      }
    },
    // 获取联系人
    async getContactList() {
      if (this.warehouseInfo.warehouseCmp && parseInt(this.warehouseInfo.warehouseCmp) > 0 && (!this.contactList || this.contactList.length <= 0)) {
        const company = new Company({ cmpIdx: this.warehouseInfo.warehouseCmp })
        this.contactList = await company.getContactsBycmpIdx()
        this.isNeedLoadContact = false
      }
    },
    /**
     * 旧的联系人控件添加数据
     * @param company
     * @param warehouseDetail
     */
    getAddressText(company, warehouseDetail) {
      if (!warehouseDetail || warehouseDetail.length === 0) {
        this.warehouseInfo.warehouseAddress = company.address
      }
      if (warehouseDetail && warehouseDetail.length === 1) {
        const warehouse = warehouseDetail[0]
        if (StrUtils.isEmpty(warehouse.warehouseContactTel) &&
          StrUtils.isEmpty(warehouse.warehouseContact) &&
          StrUtils.isEmpty(warehouse.warehouseAddress)) {
          this.warehouseInfo.warehouseAddress = company.address
        }
      }
    },

    /**
     * 旧的联系人控件添加数据
     * @param wi
     * @param w
     */
    contactsOldData(wi, w) {
      if (wi || w) {
        const list = this.contactList
        const c = {
          telephone: '',
          contactPerson: ''
        }
        if (wi) {
          c.telephone = !wi.warehouseContactTel ? '' : wi.warehouseContactTel
          c.contactPerson = !wi.warehouseContact ? '' : wi.warehouseContact
        }
        if (w) {
          c.telephone = !w.warehouseContactTel ? '' : w.warehouseContactTel
          c.contactPerson = !w.warehouseContact ? '' : w.warehouseContact
        }
        let add = true
        for (const ct of list) {
          if (ct.contactPerson === c.contactPerson && ct.telephone === c.telephone) {
            add = false
            break
          }
        }
        if (add) {
          list.push(c)
        }
        this.contactList = list

        // 双向绑定 vue 不需要
      /*  this.warehouseInfo.warehouseContact = (wi == null) ? w.warehouseContact : wi.warehouseContact
        this.warehouseInfo.warehouseContactTel = (wi == null) ? w.warehouseContactTel : wi.warehouseContactTel*/
      }
    },
    /**
     * 验证下拉框中使用仓库值还是合作伙伴值
     */
    checkContactList(defaultWarehouse) {
      // 名称非仓库 且非合作伙伴 ，默认用仓库
      let add = true
      if (defaultWarehouse && (defaultWarehouse.warehouseContactTel || defaultWarehouse.warehouseContact)) {
        add = false
      }
      return add
    },
    // 加载仓库信息
    loadJobWarehouseCmp() {

    },
    isNullData() {
      this.warehouseNameList = []
      this.contactList = []
      this.warehouseInfo.warehouseContactTel = ''
      this.warehouseInfo.warehouseContact = ''
      this.warehouseInfo.warehouseAddress = ''
      this.warehouseInfo.warehouseName = ''
      this.warehouseInfo.mapFile = ''
      this.warehouseInfo.remarks = ''
    },
    /**
     * 自动计算日期
     */
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.warehouseInfo, 'RE')
    },

    async getDefaultWarehouse(companyCache) {
      // 获取公司下的仓库List
      const companyUuid = companyCache.uuid
      this.warehouseNameList = []
      await getWarehouseDetail(companyUuid).then(async res => {
        if (res.data.length > 0) {
          this.warehouseNameList = res.data
        }
      })
      // 获取 公司下的默认仓库
      let warehouseDefault = null
      for (const warehouse of this.warehouseNameList) {
        if (warehouse.defaultWarehouse) {
          warehouseDefault = warehouse
          break
        }
      }
      if (!warehouseDefault) {
        if (this.warehouseNameList && this.warehouseNameList.length > 0) {
          warehouseDefault = this.warehouseNameList[0]
        }
      }
      return warehouseDefault
    },
    async warehouseChangeHandler(warehouseCmp) {
      this.job.warehouseCmp = warehouseCmp || 0
      this.job.warehouseRecord = this.job.warehouseCmp
      this.bakWarehouseCmp = this.job.warehouseCmp

      this.isNullData()
      await this.getContactList()
      await this.loadChargeHandler(warehouseCmp)
    },

    // 仓库更改-联动
    async loadChargeHandler(warehouseCmp) {
      if (!warehouseCmp || warehouseCmp === 0) {
        this.warehouseInfo.remarks = ''
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(warehouseCmp))
      if (!companyCache) return

      // 当装箱费用先输入时已经创建了费用，再输入仓库，将仓库同步至装箱费的结算单位中
      this.packingCharge = this.getCost()
      if (this.chargeIsModified(this.packingCharge)) {
        await this.setChargeInfo(this.packingCharge)
      }

      // 获取公司下的仓库List & 默认仓库
      const warehouse = await this.getDefaultWarehouse(companyCache)
      if (warehouse) {
        this.warehouseInfo.warehouseContactTel = warehouse.warehouseContactTel
        this.warehouseInfo.warehouseContact = warehouse.warehouseContact
        this.warehouseInfo.warehouseAddress = warehouse.warehouseAddress
        this.warehouseInfo.warehouseName = warehouse.warehouseName
        this.warehouseInfo.mapFile = warehouse.mapFile
        this.setRemarks(warehouse.remarks)
        this.job.warehouseName = warehouse.warehouseName

        this.contactsOldData(null, warehouse)
        // 从cargo 操作上看 此此处未使用 公司下的联系人 !this.openWarehouse &&
        if (!this.warehouseInfo.warehouseContact && !this.warehouseInfo.warehouseContactTel) {
          await this.loadContactsFunc()
        }
      } else {
        await this.loadContactsFunc()
      }
      this.getAddressText(companyCache, this.warehouseNameList)
    },
    async loadContactsFunc() {
      // 实现 loadContactsFunc
      if (this.warehouseInfo.warehouseCmp && parseInt(this.warehouseInfo.warehouseCmp) > 0 && (!this.contactList || this.contactList.length <= 0)) {
        const company = new Company({ cmpIdx: this.warehouseInfo.warehouseCmp })
        this.contactList = await company.getContactsBycmpIdx()
        this.isNeedLoadContact = false
      }
      if (this.contactList && this.contactList.length > 0) {
        for (const ct of this.contactList) {
          if (ct.defaultContact) {
            this.warehouseInfo.warehouseContact = ct.contactPerson
            this.warehouseInfo.warehouseContactTel = ct.telephone
            break
          }
        }
      } else {
        this.warehouseInfo.warehouseContact = ''
        this.warehouseInfo.warehouseContactTel = ''
      }
    },
    /**
     * 仓库名称change
     * @param warehouseName
     */
    nameChangeHandler(warehouseName) {
      this.job.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        this.warehouseInfo.warehouseContactTel = w.warehouseContactTel
        this.warehouseInfo.warehouseContact = w.warehouseContact
        this.warehouseInfo.warehouseAddress = w.warehouseAddress
        this.warehouseInfo.mapFile = w.mapFile
        this.setRemarks(w.remarks)
      } else {
        this.warehouseInfo.warehouseContactTel = ''
        this.warehouseInfo.warehouseContact = ''
        this.warehouseInfo.warehouseAddress = ''
        this.warehouseInfo.mapFile = ''
        this.warehouseInfo.remarks = ''
      }
    },
    setRemarks(remarks) {
      if (remarks) {
        this.warehouseInfo.remarks = remarks
      }
    },
    /**
     * 联系人下拉框change
     * @param warehouseContact
     */
    contactsChangeHandler(contactPerson) {
      const w = this.contactList.find(item => item.contactPerson === contactPerson)
      if (w != null) {
        this.warehouseInfo.warehouseContactTel = w.telephone
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.warehouseInfo.warehouseContact = event.target.value
      }
    },
    onVisibleChange(e) {
      if (e) {
        this.setSelectedLabel()
      }
      this.$emit('visible-change', e)
    },
    setSelectedLabel() {
      this.$nextTick(() => {
        const select = this.$refs.advanceSelectRef
        if (select.query) {
          select.selectedLabel = select.query
        }
      })
    },
    // 组装打印参数
    getPrintData() {
      if (this.job) {
        const params = {}
        // params.jobuuid = this.job.uuid
        // params.JOB_UUID = this.job.uuid
        // params.truckinguuid = null
        // params.USER_ID = this.$store.getters.userId
        PrintTemplateUtil.buildPrintDataByLocalService(this.job, params)
        if (this.job.lob === 'RE' || this.job.lob === 'RI') {
          params.category = 'LOCALSERVICE_RE'
          params.ctx = new RailwayExportJob(this.job)
        } else {
          params.category = 'LOCALSERVICE'
          params.ctx = new SeaExportJob(this.job)
        }
        // TemplateSelectorWin.getInstance().showThisWin(job, "LOCALSERVICE", params, this);
        this.$logger.log('params', params)
        return params
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  .warehouse-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 10px 0 20px 10px;
    .el-form{
      width: 500px;
      label{
        font-weight: normal;
      }
      .auto-width{
        .el-form-item__content{
          & > span{
            margin-left: 0;
            display: inline-block;
          }
        }
      }
      .el-form-item__content{
        & > span{
          margin-left: 5px;
        }
        & > label{
          margin-right: 10px;
          margin-left: 25px;
        }
      }
      &:nth-of-type(2){
        margin-left: 100px;
      }
    }
  }
}
</style>
